import { MenuItem, Select } from '@mui/material'
import React from 'react'
import { type NewOrganizationInformation, type BaseSlo } from 'services'
import { useOrganizationTypeLuts, type OrgFilters } from 'components'
import { type SloFilters } from 'pages'

export interface OrgTypesOption {
  id: number
  descShort: string
  descLong: string
}

export interface OrgTableTypeFiltersProps {
  id?: string
  filters: OrgFilters | NewOrganizationInformation | SloFilters | BaseSlo
  updateFilters: (filters: any) => void
  disabled: boolean
  label?: string
}

export const OrganizationsTypeSelect: React.FC<OrgTableTypeFiltersProps> = ({ filters, updateFilters, disabled, label = 'Type', id = 'type-select' }) => {
  const { lutValues: organizationTypeLutValues, loading: loadingOrganizationTypeLutvalues } = useOrganizationTypeLuts()

  const getTypeValue = (): number => {
    if ('type' in filters) {
      return filters.type
    }
    if ('orgTypeId' in filters) {
      return filters.orgTypeId ?? 0
    }
    if ('orgType' in filters) {
      return filters.orgType?.id ?? 0
    }
    return 0
  }

  return (
        <Select
            label={label}
            id={id}
            value={getTypeValue()}
            disabled={disabled}
            onChange={(event, child) => { updateFilters({ type: Number(event.target.value) }) }}
        >
            <MenuItem value="0" disabled={loadingOrganizationTypeLutvalues}>
                <em>None</em>
            </MenuItem>
            {organizationTypeLutValues.organizationTypes?.map(value => <MenuItem key={value.id} value={value.id}>{value.descShort} ({value.typeCode})</MenuItem>)}

        </Select>
  )
}
